import { SitProModel } from '../models/sitpro.model';
import { CcdStringUtils } from '../../../../services/ccd-string.utils';

export class SitProModelAdapter {

    public sitProModel : SitProModel;

    /**
     * Constructeur
     */
    constructor(sitProModel : SitProModel) {
        this.sitProModel = sitProModel;
    }

    /**
     * Q1 Codes possibles
     * 
     * - ACT_INCONNUE
     * - ETU
     * - EBO
     * - ST_RSA
     * - CONGE_MATPAT
     * 
     * @param codeSituation 
     */
    setCodeSituation(codeSituation: string): void {
        this.sitProModel.isCodeSituationDefini = (codeSituation !== undefined && codeSituation.trim().length > 0);
        this.sitProModel.codeSituation = codeSituation;
    }

    /**
     * Q2
     * @param isActPro 
     */
    setEnActivite(isActPro: string) {
        this.sitProModel.isEnActiviteDefini = CcdStringUtils.isStringBoolean(isActPro);
        this.sitProModel.enActivite = CcdStringUtils.stringToBoolean(isActPro);
    }

    /**
    * Q2.2
    * @param isChomage 
    */
    setAuChomage(isChomage: string) {
        this.sitProModel.isAuChomageDefini = CcdStringUtils.isStringBoolean(isChomage);
        this.sitProModel.auChomage = CcdStringUtils.stringToBoolean(isChomage);
    }

    /**
     * Q3
     * @param isIndemnite 
     */
    setIndeminite(isIndemnite: string) {
        this.sitProModel.isIndemniteDefini = CcdStringUtils.isStringBoolean(isIndemnite);
        this.sitProModel.indemnite = CcdStringUtils.stringToBoolean(isIndemnite);
    }

    /**
     * Est beneficiaire du RSA ?
     */
    isBeneficiaireRSA(): boolean {
        return (this.sitProModel.codeSituation === "ST_RSA");
    }

    /**
     * Est étudiant boursier ?
     */
    isEtudiantBoursier(): boolean {
        return (this.sitProModel.codeSituation === "EBO");
    }

    /**
     * Est étudiant non boursier ?
     */
    isEtudiantNonBoursier(): boolean {
        return (this.sitProModel.codeSituation === "ETU");
    }

    /**
     * Est en congé parental ?
     */
    isCongeParental(): boolean {
        return (this.sitProModel.codeSituation === "CONGE_MATPAT");
    }

    isActiviteInconnue(): boolean {
        return (this.sitProModel.codeSituation === "ACT_INCONNUE");
    }

    isCodeSituationDefini() : boolean {
        return this.sitProModel.isCodeSituationDefini;
    }

    isEnActiviteDefini() : boolean {
        return this.sitProModel.isEnActiviteDefini;
    }

    isEnActivite() : boolean {
        return this.sitProModel.enActivite;
    }
}
